import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faTrashCan, faXmark } from "@fortawesome/free-solid-svg-icons";
import "./EditableTable.css";

const EditableTable = ({
  columns = [],
  data = [],
  editingIndex = null,
  onEdit = () => {},
  onSave = () => {},
  onCancel = () => {},
  onDelete = () => {},
  renderCell = () => {},
  renderEditCell = () => {},
  className = "",
  style = {},
}) => {
  return (
    <table className={`editable-table ${className}`} style={style}>
      <thead>
        <tr>
          {columns.map((column, index) => (
            <th
              key={index}
              style={{
                width: column.width || "auto",
                textAlign: column.align || "left",
              }}
            >
              {column.label}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {data.map((row, rowIndex) => {
          const isEditing = editingIndex === rowIndex;

          return (
            <tr key={rowIndex}>
              {columns.map((column, colIndex) => {
                // Skip the action column in data rendering
                if (column.type === "actions") {
                  return (
                    <td key={colIndex}>
                      <div className="action-buttons" style={{ margin: "0px" }}>
                        {isEditing ? (
                          <>
                            <button
                              className="save-row"
                              onClick={() => onSave(rowIndex)}
                            >
                              <FontAwesomeIcon icon={faCheck} />
                            </button>
                            <button
                              className="cancel-row"
                              onClick={() => onCancel(rowIndex)}
                            >
                              <FontAwesomeIcon icon={faXmark} />
                            </button>
                          </>
                        ) : (
                          <>
                            <button
                              className="edit-row"
                              onClick={() => onEdit(rowIndex)}
                            >
                              <svg
                                width="18"
                                height="18"
                                viewBox="0 0 15 15"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M13.4192 5.57534L9.93101 2.12329L11.0801 0.972603C11.3947 0.657534 11.7811 0.5 12.2394 0.5C12.6976 0.5 13.084 0.657534 13.3987 0.972603L14.5477 2.12329C14.8623 2.43836 15.0265 2.81849 15.0402 3.2637C15.0538 3.7089 14.9034 4.08904 14.5888 4.40411L13.4192 5.57534ZM12.2291 6.78767L3.52919 15.5H0V12.0068L8.74093 3.29452L12.2291 6.78767Z"
                                  fill="white"
                                />
                              </svg>
                            </button>
                            <button
                              className="delete-row"
                              onClick={() => onDelete(rowIndex)}
                            >
                              <FontAwesomeIcon icon={faTrashCan} />
                            </button>
                          </>
                        )}
                      </div>
                    </td>
                  );
                }

                // Render data cells
                return (
                  <td
                    key={colIndex}
                    style={{
                      textAlign: column.align || "left",
                    }}
                  >
                    {isEditing
                      ? renderEditCell(row, column.field, rowIndex)
                      : renderCell(row, column.field, rowIndex)}
                  </td>
                );
              })}
            </tr>
          );
        })}
      </tbody>
    </table>
  );
};

export default EditableTable;

